import React from "react";

const WspolnotaRozliczenieHistoriaTHead = () => {

    return (
        <thead>
            <tr>
                <th>
                    Mieszkaniec
                </th>
                <th>
                    Adres
                </th>
                <th>
                    Kanał
                </th>
                <th>
                    Data
                </th>
                <th>
                    Kto wysłał
                </th>
                <th>
                    Kwota
                </th>
                <th>
                    Uwagi
                </th>
            </tr>
        </thead>
    )
}

export default WspolnotaRozliczenieHistoriaTHead;